import { makeStyles } from '@material-ui/core/styles';
import fonts from '../../../../../styles/fonts';
import { colors } from '../../../../../styles/colors';

const useStyles = makeStyles({
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 24px',
    alignItems: 'center',
    height: '67px',
    width: '100%',
    borderBottom: `1px solid ${colors.lightGray}`,
  },
  headerIcon: {
    cursor: 'pointer',
  },
  modal: {
    position: 'absolute',
    width: 629,
    height: 307,
    backgroundColor: '#ffffff',
    borderRadius: '4px',
    boxShadow:
      '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);',
    padding: ' 0px',
    top: '50%',
    left: '50%',
    right: '0%',
    bottom: '0%',
    transform: 'translate(-50%, -50%)',
  },
  modalBody: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px',
    '&::nth-child(2)': {
      background: '#002277',
    },
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '58px',
    padding: '40px 34px 40px',
  },
  modalText: {
    padding: '24px 0px 0px 24px',
  },
  textfield: {
    width: '282px',
    height: '56px',
  },
  container: {
    textAlign: 'center',
  },
  headerTitle: {
    fontSize: fonts.sizes.medium,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '24px',
    color: colors.black,
  },
  root: {
    '& .MuiInputAdornment-positionEnd > button': {
      color: colors.black,
    },
  },
});

export default useStyles;
